import { Component, Input, OnInit } from '@angular/core';
import { Task } from '../../models/task.model';
import { sortActivityRowsOnComparison } from '../../../utils/common-methods';
import { TaskService } from '../../../core/task.service';

@Component({
  selector: 'app-activity-table',
  templateUrl: './activity-table.component.html',
  styleUrl: './activity-table.component.scss',
})
export class ActivityTableComponent implements OnInit {
  private _projectId: number | 'all' = 0;

  @Input() set projectId(value: number | 'all') {
    this._projectId = value;
    this.onIdProjectChange();
  }
  get projectId(): number | 'all' {
    return this._projectId;
  }
  @Input() activityTabsList? = [
    'Actividades recientes',
    'Vencidas',
    'Próximas',
  ];
  @Input() extraActionButtonText: string = 'Ir a mi PM';
  public currentTab = 0;
  public activityTableData: Task[] = [];

  changeActivityTab(tab: number) {
    this.currentTab = tab;
  }

  activityColumnsList = [
    {
      title: 'Tarea',
      compare: sortActivityRowsOnComparison('taskName'),
      priority: 1,
    },
    {
      title: 'Asignado a',
      compare: sortActivityRowsOnComparison('assignedToName'),
      priority: 2,
    },
    {
      title: 'Estado',
      compare: sortActivityRowsOnComparison('activityStatus'),
      priority: 3,
    },
    {
      title: 'Fecha',
      compare: sortActivityRowsOnComparison('endDate'),
      priority: 4,
    },
  ];

  constructor(private taskService: TaskService) {}

  ngOnInit(): void {
    if (this.projectId !== 0) {
      this.onIdProjectChange;
    }
  }

  private onIdProjectChange(): void {
    if (this._projectId !== 0) {
      this.taskService.getAllRecentActivities(this._projectId).subscribe(
        (data) => {
          this.activityTableData = data;
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      this.activityTableData = [];
    }
  }
}
